import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Forgot from './pages/auth/Forgot';
import Reset from './pages/auth/Reset';
import Sidebar from './components/sidebar/Sidebar';
import Dashboard from './pages/dashboard/Dashboard';
import Layout from './components/layout/Layout';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getLoginStatus } from './services/authService';
import { SET_LOGIN } from './redux/features/auth/authSlice';
import AddProduct from './pages/addProduct/AddProduct';
import AddRequest from './pages/addRequest/AddRequest';
import ProductDetail from './components/product/productDetail/ProductDetail';
import EditProduct from './pages/editProduct/EditProduct';
import EditRequest from './pages/editRequest/EditRequest';
import Profile from './pages/profile/Profile';
import EditProfile from './pages/profile/EditProfile';
import { MapLayout } from './pages/map/MapLayout';
import { CssBaseline } from '@mui/material';
import Contact from './pages/contact/Contact';
import RequestList from './pages/requestList/RequestList';

axios.defaults.withCredentials = true;

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    async function loginStatus() {
      const status = await getLoginStatus();
      dispatch(SET_LOGIN(status));
    }
    loginStatus();
  }, [dispatch]);

  return (
    <BrowserRouter>
      <ToastContainer />
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/resetpassword/:resetToken" element={<Reset />} />

        <Route
          path="/dashboard"
          element={
            <Sidebar>
              <Layout>
                <Dashboard />
              </Layout>
            </Sidebar>
          }
        />
        <Route
          path="/add-product"
          element={
            <Sidebar>
              <Layout>
                <AddProduct />
              </Layout>
            </Sidebar>
          }
        />
        <Route
          path="/product-detail/:id"
          element={
            <Sidebar>
              <Layout>
                <ProductDetail />
              </Layout>
            </Sidebar>
          }
        />
        <Route
          path="/edit-product/:id"
          element={
            <Sidebar>
              <Layout>
                <EditProduct />
              </Layout>
            </Sidebar>
          }
        />
        <Route
          path="/profile"
          element={
            <Sidebar>
              <Layout>
                <Profile />
              </Layout>
            </Sidebar>
          }
        />
        <Route
          path="/edit-profile"
          element={
            <Sidebar>
              <Layout>
                <EditProfile />
              </Layout>
            </Sidebar>
          }
        />
          <Route
          path="/\contact-us"
          element={
            <Sidebar>
              <Layout>
                <Contact />
              </Layout>
            </Sidebar>
          }
        />
        <Route
          path="/map"
          element={
            <Sidebar>
              <Layout>
                <MapLayout />
              </Layout>
            </Sidebar>
          }
        />
        <Route
          path="/add-request"
          element={
            <Sidebar>
              <Layout>
                <AddRequest />
              </Layout>
            </Sidebar>
          }
        />
        <Route
          path="/edit-request/:id"
          element={
            <Sidebar>
              <Layout>
                <EditRequest />
              </Layout>
            </Sidebar>
          }
        />
        <Route
          path="/request-list"
          element={
            <Sidebar>
              <Layout>
                <RequestList />
              </Layout>
            </Sidebar>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
